import script from "./CustomList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomList.vue?vue&type=script&setup=true&lang=ts"

import "./CustomList.vue?vue&type=style&index=0&id=1cce4c00&lang=less"

const __exports__ = script;

export default __exports__